export enum Roles {
  HK_ADMIN = 'HK Admin',
  COST_APPROVER = 'Cost Approver',
  MCDONALDS_CORPORATE = 'McDonalds Corporate',
  SERVICE_CONTROLLER = 'Service Controller',
  STORE_APPROVER = 'Store Approver',
  MCDIENSTEN = 'Mcdiensten',
  STORE_OWNER = 'Store Owner',
}
